import { FormControl, FormGroup } from '@angular/forms';

import { FormType, UIType } from './types';

export const createForm = (index: number) => {
  return new FormGroup<FormType>({
    type: new FormControl(UIType.Object, { nonNullable: true }),
    id: new FormControl(`filter_${index}`, { nonNullable: true }),
    label: new FormControl(`Фильтр ${index}`, { nonNullable: true }),
    placeholder: new FormControl(null),
    order: new FormControl(index, { nonNullable: true }),
    visible: new FormControl(true, { nonNullable: true }),
  });
};
